import { useMemo, createContext, useContext } from 'react';
import { useFind } from '../hooks/useDataFetchers';

import { camelize } from './tools';

export const useValue = (me, props = {}) => {
  return useMemo(() => {
    const { jsonapiType } = me.klass;
    return {
      me,
      ...props,
      ...Object.values(me.klass.attributeList).reduce((acc, { name }) => {
        const camelName = camelize(name);
        return { ...acc, [camelName]: me[camelName] };
      }, {}),
      type: jsonapiType,
      useFetch: (filter, options) =>
        /* returns un "fetcher" qu'il faut passer à useResult */
        useFind(me.id, me.jsonapiType /* ? me.klass.jsonapiType ? */, filter, {
          ...options,
          initialValue: me,
        }),
      useRelationship: (relationship) => {
        throw Error('TODO : utiliser usePaginate');
      },
      // pour le useRelationship d'origine, utiliser useFetch avec un filter={includes:relationship}
      say: (action, params = {}) =>
        props.say
          ? props.say(action, { type: jsonapiType, id: me.id, ...params })
          : console.warn(
              `'say' not specified in ModelList for '${jsonapiType}'`,
            ),
    };
  }, [me, props]);
};

const addModelContext = (Component) => {
  const context = createContext();
  return [
    (props) => (
      <context.Provider value={props}>
        <Component {...props} />
      </context.Provider>
    ),
    () => useContext(context),
  ];
};
export { addModelContext };
